import { ApiError } from '../../api/errors';
import { Button } from './Button';
import { FormAlert } from './Field';

/*
 * Відповідь сервера у формі: повідомлення полів — біля полів (fieldError), решта — тут, дослівно.
 * Чутливі дані (номери карток, IBAN, паролі, паспортні дані) — попередження з вибором: замаскувати
 * й зберегти (maskSensitive) або зберегти як є (allowSensitive) — якщо операція це підтримує.
 */

/** Повідомлення сервера для поля (точний збіг назви поля в errors[]). */
export function fieldError(error: unknown, field: string): string | undefined {
  return error instanceof ApiError ? error.fieldError(field) : undefined;
}

export function ServerError({
  error,
  shownFields = [],
  onAllowSensitive,
  onMaskSensitive,
  title,
}: {
  error: unknown;
  /** Поля, помилки яких уже показано біля полів форми. */
  shownFields?: string[];
  onAllowSensitive?: () => void;
  onMaskSensitive?: () => void;
  title?: string;
}) {
  if (!error) return null;
  if (!(error instanceof ApiError)) return <FormAlert detail="Не вдалося виконати дію. Спробуйте ще раз." />;
  if (error.isQueued) return <FormAlert tone="info" detail={error.detail} />;
  const items = error.messagesExcept(shownFields).filter((m) => m !== error.detail);
  if (error.isSensitive)
    return (
      <FormAlert tone="warning" title={title ?? 'Схоже, у тексті є чутливі дані'} detail={error.detail} items={items}>
        {(onMaskSensitive || onAllowSensitive) && (
          <div className="mt-2 flex flex-wrap gap-2">
            {onMaskSensitive && (
              <Button size="sm" onClick={onMaskSensitive}>
                Замаскувати й зберегти
              </Button>
            )}
            {onAllowSensitive && (
              <Button size="sm" variant="ghost" onClick={onAllowSensitive}>
                Зберегти як є
              </Button>
            )}
          </div>
        )}
      </FormAlert>
    );
  return <FormAlert title={title} detail={error.detail} items={items} />;
}

/** Текст помилки для сповіщення (toast): detail і повідомлення полів. */
export function errorText(error: unknown, fallback = 'Спробуйте ще раз.'): string {
  if (error instanceof ApiError) {
    const extra = error.errors.map((x) => x.message).filter((m) => m !== error.detail);
    return [error.detail, ...extra].join(' ');
  }
  return fallback;
}
